/*
 * Capable Health API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v0.3
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 3.0.72
 *
 * Do not edit the class manually.
 *
 */
import ApiClient from "../ApiClient";
import InlineResponse2002 from '../model/InlineResponse2002';
import InlineResponse2003 from '../model/InlineResponse2003';
import InlineResponse422 from '../model/InlineResponse422';
import PatientActivationsBody from '../model/PatientActivationsBody';
import PatientActivationsVerifyBody from '../model/PatientActivationsVerifyBody';

/**
* PatientActivations service.
* @module api/PatientActivationsApi
* @version v0.3
*/
export default class PatientActivationsApi {

    /**
    * Constructs a new PatientActivationsApi.
    * @alias module:api/PatientActivationsApi
    * @class
    * @param {module:ApiClient} [apiClient] Optional API client implementation to use,
    * default to {@link module:ApiClient#instanc
    e} if unspecified.
    */
    constructor(apiClient) {
        this.apiClient = apiClient || ApiClient.instance;
    }

    /**
     * Callback function to receive the result of the patientActivationsPost operation.
     * @callback moduleapi/PatientActivationsApi~patientActivationsPostCallback
     * @param {String} error Error message, if any.
     * @param {module:model/InlineResponse2003{ data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Activate an auto-enrolled patient account
     * @param {Object} opts Optional parameters
     * @param {module:model/PatientActivationsBody} opts.body
     * @param {module:api/PatientActivationsApi~patientActivationsPostCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link <&vendorExtensions.x-jsdoc-type>}
     */
    patientActivationsPost(opts, callback) {
      opts = opts || {};
      let postBody = opts['body'];

      let pathParams = {

      };
      let queryParams = {

      };
      let headerParams = {

      };
      let formParams = {

      };

      let authNames = [];
      let contentTypes = ['application/json'];
      let accepts = ['application/json'];
      let returnType = InlineResponse2003;

      return this.apiClient.callApi(
        '/patient_activations', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }
    /**
     * Callback function to receive the result of the patientActivationsVerifyPost operation.
     * @callback moduleapi/PatientActivationsApi~patientActivationsVerifyPostCallback
     * @param {String} error Error message, if any.
     * @param {module:model/InlineResponse2002{ data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Verify an auto-enrollment invitation
     * @param {Object} opts Optional parameters
     * @param {module:model/PatientActivationsVerifyBody} opts.body
     * @param {module:api/PatientActivationsApi~patientActivationsVerifyPostCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link <&vendorExtensions.x-jsdoc-type>}
     */
    patientActivationsVerifyPost(opts, callback) {
      opts = opts || {};
      let postBody = opts['body'];

      let pathParams = {

      };
      let queryParams = {

      };
      let headerParams = {

      };
      let formParams = {

      };

      let authNames = [];
      let contentTypes = ['application/json'];
      let accepts = ['application/json'];
      let returnType = InlineResponse2002;

      return this.apiClient.callApi(
        '/patient_activations/verify', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

}
